export default __webpack_public_path__ + "static/media/Wristband of the Faceless Sphinx.b8c4eb45.jpg";